import { IconPrefix, library } from "@fortawesome/fontawesome-svg-core";
import { fas, IconName } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

library.add(fas, fab);

const Icon: React.FC<{
  reactIconsIcon?: string | null;
  className: string | null;
}> = (props) => {
  const { reactIconsIcon, className } = props || {};

  if (!reactIconsIcon) return null;

  const getIconDefinition = (): [IconPrefix, IconName] => {
    const isBrand = Object.values(fab).some(
      (icon: any) => icon.iconName === reactIconsIcon,
    );

    return [isBrand ? "fab" : "fas", reactIconsIcon as IconName];
  };

  return (
    <FontAwesomeIcon
      icon={getIconDefinition()}
      aria-hidden="true"
      className={clsx("mr-3 pb-1 mt-1 text-base text-gray-600", className)}
    />
  );
};

export { Icon };
